export default "__VITE_ASSET__DVoDwmsQ__"